/* global _wq */

Wee.fn.make('freeform', {
	init: function() {

		var priv = this.$private;

		Wee.$hide('.hidden.branching');

		$('ref:freeform-branching').on('change', function(e, el) {
			var value = e.target.value;

			var subindustries = window.branching.subindustries[value];
			var contactFunctions = window.branching.contact_functions[value];

			var subindustriesSelect = $('ref:freeform-branching-subindustries')[0];
			var contactFunctionSelect = $('ref:freeform-branching-contactfunctions')[0];

			priv.removeOptions(subindustriesSelect);
			priv.removeOptions(contactFunctionSelect);

			Wee.$show('.hidden.branching');

			if (typeof subindustries != 'undefined') {
				var option = priv.generateSelectOption('--PLEASE SELECT--', '');
				priv.appendOption(subindustriesSelect, option);

				subindustries.forEach(function (item, index) {
					var option = priv.generateSelectOption(item, item);

					priv.appendOption(subindustriesSelect, option);
				});
			}

			if (typeof contactFunctions != 'undefined') {
				var option = priv.generateSelectOption('--PLEASE SELECT--', '');

				priv.appendOption(contactFunctionSelect, option);

				contactFunctions.forEach(function (item, index) {
					var option = priv.generateSelectOption(item, item);

					priv.appendOption(contactFunctionSelect, option);
				});
			}

			Wee.$exec('dropdown:update', {
				args: [
					'ref:freeform-branching-subindustries'
				]
			});

			Wee.$exec('dropdown:update', {
				args: [
					'ref:freeform-branching-contactfunctions'
				]
			});
		});
	}
}, {
	generateSelectOption: function(label, value) {
		var option = document.createElement('option');
		option.appendChild(document.createTextNode(label));
		option.value = value;

		return option;
	},

	appendOption: function(select, option) {
		select.appendChild(option);
	},

	removeOptions: function(select) {
		for (var i = select.options.length - 1 ; i >= 0 ; i--) {
			select.remove(i);
		}
	}
});